import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  List,
  ListItem,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu"; // Hamburger Icon
import CloseIcon from "@mui/icons-material/Close"; // Close Icon
import Logo from "./img/Logo.png";
import "../styles/components-styles/Navbar.css";

const Navbar = ({ scrollToTestimonials }) => {
  const items = [
    "Home",
    "About",
    "Courses",
    "Students",
    "Creative Writing Course",
  ];
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  // Effect to scroll to testimonials after navigating to home
  useEffect(() => {
    if (location.state?.scrollToTestimonials) {
      scrollToTestimonials();
    }
  }, [location, scrollToTestimonials]);

  // Toggle menu function
  const toggleMenu = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget); // Toggle menu
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleNavigation = (item) => {
    setMenuOpen(false);
    closeMenu();
    window.scrollTo(0, 0);

    if (item === "Students") {
      if (
        location.pathname === "/about" ||
        location.pathname === "/creative-writing-course"
      ) {
        navigate("/", { state: { scrollToTestimonials: true } });
      } else {
        scrollToTestimonials();
      }
    } else {
      navigate(`/${item.toLowerCase().replace(/\s+/g, "-")}`);
    }
  };

  const contactClick = () => {
    navigate("/ContactUs");
  };

  return (
    <Box component="nav" className="navbar">
      <Box className="navbar-container">
        {/* Logo */}
        <Box className="navbar-logo">
          <img src={Logo} alt="Logo" />
        </Box>

        {/* Navigation Links */}
        <List className={`navbar-list ${menuOpen ? "open" : ""}`}>
          {items.map((item, index) => (
            <ListItem
              key={index}
              className="navbar-item"
              onClick={() => {
                setMenuOpen(false); // Close menu on item click (mobile)
                window.scrollTo(0, 0);
                if (item === "Students") {
                  if (
                    location.pathname === "/about" ||
                    location.pathname === "/creative-writing-course"
                  ) {
                    navigate("/", { state: { scrollToTestimonials: true } });
                  } else {
                    scrollToTestimonials();
                  }
                }
              }}
            >
              {item === "Students" ? (
                <span className="navbar-link">{item}</span>
              ) : (
                <NavLink
                  to={`/${item.toLowerCase().replace(/\s+/g, "-")}`}
                  className={({ isActive }) =>
                    isActive ? "navbar-link-active" : "navbar-link"
                  }
                >
                  {item}
                </NavLink>
              )}
            </ListItem>
          ))}
        </List>

        {/* Contact Button */}
        <Button
          variant="contained"
          className="navbar-button"
          onClick={contactClick}
        >
          Contact Us
        </Button>

        {/* Hamburger Menu Button */}
        <IconButton className="hamburger-btn" onClick={toggleMenu}>
          {anchorEl ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={closeMenu}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {items.map((item, index) => (
            <MenuItem key={index} onClick={() => handleNavigation(item)}>
              {item}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </Box>
  );
};

export default Navbar;
